import { require200Status } from "../../utils/response.js";
import { transformWithSpec } from "../../../utils/response.js";
function withdrawEndpoints(builder) {
  return {
    withdraw: builder.mutation({
      invalidatesTags: ["funding-tx"],
      query: (body) => ({
        url: `/member/withdraw`,
        validateStatus: require200Status,
        method: "POST",
        body
      }),
      transformResponse: transformWithSpec()
    })
  };
}
export {
  withdrawEndpoints as default
};
